module.exports = __webpack_public_path__ + "img/de1d9cc.png";